const ServicesSection = () => {
  const services = [
    {
      title: 'Access Control Systems',
      description: 'Keycard, biometric, and mobile access solutions',
      icon: 'ri-key-2-line',
      image: 'https://public.readdy.ai/ai/img_res/964e9eee429ecc3818999c07e37e556b.jpg',
      bgColor: 'bg-dark',
      textColor: 'text-white',
    },
    {
      title: 'IP Camera Systems',
      description: 'High-definition surveillance solutions',
      image: 'https://readdy.ai/api/search-image?query=professional%20IP%20security%20cameras%20mounted%20on%20building%20exterior%20surveillance%20system%20installation%20commercial%20property%20simple%20background%20modern%20security%20equipment%20high%20quality&width=600&height=400&seq=ip-camera-install&orientation=landscape',
      bgColor: 'bg-white',
      textColor: 'text-dark',
      isImageBg: true,
    },
    {
      title: 'Intercom Systems',
      description: 'Video and audio communication solutions',
      icon: 'ri-phone-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20video%20intercom%20panel%20touchscreen%20display%20mounted%20on%20wall%20simple%20clean%20background%20professional%20security%20equipment%20close-up%20high%20quality%20photography&width=600&height=400&seq=intercom-install&orientation=landscape',
      bgColor: 'bg-gray-50',
      textColor: 'text-dark',
    },
    {
      title: 'Intrusion Detection',
      description: 'Advanced motion sensors and alarm systems',
      icon: 'ri-alarm-warning-line',
      image: 'https://readdy.ai/api/search-image?query=motion%20sensor%20detector%20mounted%20on%20ceiling%20or%20wall%20simple%20clean%20background%20professional%20security%20equipment%20installation%20close-up%20high%20quality%20photography&width=600&height=400&seq=intrusion-detection&orientation=landscape',
      bgColor: 'bg-primary',
      textColor: 'text-white',
    },
  ];

  return (
    <section className="py-24 bg-[#F5F5F0]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <h2 className="text-5xl font-serif font-bold text-center text-dark mb-16">
          Our Security Expertise
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bgColor} rounded-2xl overflow-hidden group hover:scale-105 transition-transform duration-300 cursor-pointer`}
            >
              {service.isImageBg ? (
                <div className="relative h-[450px]">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  <div className="absolute top-6 left-6">
                    <div className="inline-flex items-center gap-2 bg-dark/80 backdrop-blur-sm px-4 py-2 rounded-full">
                      <i className="ri-camera-line text-white"></i>
                      <span className="text-white text-sm font-medium uppercase tracking-wide">
                        Surveillance
                      </span>
                    </div>
                  </div>
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-3xl font-bold text-white">{service.title}</h3>
                  </div>
                </div>
              ) : (
                <div className="p-8 h-[450px] flex flex-col">
                  <div className={`w-16 h-16 rounded-full bg-gray-700 flex items-center justify-center mb-6`}>
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className={`text-2xl font-bold ${service.textColor} mb-3`}>
                    {service.title}
                  </h3>
                  <p className={`text-sm ${service.textColor === 'text-white' ? 'text-gray-300' : 'text-gray-600'} mb-auto`}>
                    {service.description}
                  </p>
                  <div className="mt-6 rounded-xl overflow-hidden h-48">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;